export const initialState = {
	data: [],
	boolMap: {},
	hasDataMap: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
